import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import LanguageGridButton from './LanguageGridButton';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

const LanguageSelectModal = (props) => {
    const {isOpen, toggleModal, viewer} = props;
    let {locale_codes, locale} = viewer.language;
    
    
    return (
    <Transition.Root show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-40" onClose={toggleModal}>
          <Transition.Child id="language-select-modal"
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-lg items-middle justify-center py-8 text-center sm:items-center sm:p-0 md:p-4 mt-12 md:mt-8">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-6 pt-4 pb-4 text-left shadow-xl transition-all sm:my-4 sm:w-full sm:max-w-xl sm:p-4 md:w-full">
                  <div>
                    <div className="">
                      <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                        <FormattedMessage id='app.choose_language' defaultMessage="Choose language" />
                      </Dialog.Title>
                      <div className="mt-2">
                        <div className="grid grid-cols-2 gap-4">
                        {locale_codes.map((lang, i) =>
                            <LanguageGridButton key={`lang-button-${i}`}
                              language={lang}
                              activeLanguage={locale}
                              toggleModal={toggleModal}  />
                        )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <form className="mt-6">
                    <button
                      type="button"
                      className="inline-flex float-right justify-center rounded-md border border-transparent bg-[#1a658f] px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-[#1a658f]/80 focus:outline-none focus:ring-2 focus:ring-[#1a658f]/50 focus:ring-offset-2"
                      onClick={toggleModal}
                    >
                    <XMarkIcon className='w-5 h-5 inline'/> <FormattedMessage id='app.close' defaultMessage="Close" />
                    </button>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
    </Transition.Root>
    );
};

function mapStateToProps({viewer}) {
	return { viewer }
}

export default connect(mapStateToProps)(LanguageSelectModal);